import { EmptyState } from '@bennows/boows-react';
import { CircleCheck } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { ProblemBadges } from '../problems/ProblemBadges';
import type { TenantProblem } from '../problems/useProblems';

/** What is wrong with this tenant right now, from its live metrics (REQ-140-015). */
export function TenantProblemsTab({ problems }: { readonly problems: readonly TenantProblem[] }) {
  const { t } = useTranslation();
  if (problems.length === 0) return <EmptyState icon={<CircleCheck aria-hidden="true" />} title={t('problems.emptyTitle')} hint={t('tenant.problems.none')} />;
  return (
    <>
      <ProblemBadges problems={problems} />
      <p className="ui-console-muted">{t('tenant.problems.note')}</p>
    </>
  );
}
